import React from "react";
import "./header.css";
export default function BrandHeader() {
  return (
    <header className="brand-header flex-row">
      <h1>OPCA</h1>
    </header>
  );
}
